import InstaBrand1 from "../assets/icons/Social/InstaBrand1";
import InstaBrand2 from "../assets/icons/Social/InstaBrand2";

import TwitterBrand1 from "../assets/icons/Social/TwitterBrand1";
import TwitterBrand2 from "../assets/icons/Social/TwitterBrand2";

import FacebookBrand1 from "../assets/icons/Social/FacebookBrand1";
import FacebookBrand2 from "../assets/icons/Social/FacebookBrand2";

import LinkedinBrand1 from "../assets/icons/Social/LinkedinBrand1";
import LinkedinBrand2 from "../assets/icons/Social/LinkedinBrand2";

import TikTokBrand1 from "../assets/icons/Social/TiktokBrand1";
import TikTokBrand2 from "../assets/icons/Social/TiktokBrand2";

import LinktreeBrand1 from "../assets/icons/Social/LinktreeBrand1";
import LinktreeBrand2 from "../assets/icons/Social/LinktreeBrand2";

import SpotifyBrand1 from "../assets/icons/Social/SpotifyBrand1";
import SpotifyBrand2 from "../assets/icons/Social/SpotifyBrand2";

import PinterestBrand1 from "../assets/icons/Social/PinterestBrand1";
import PinterestBrand2 from "../assets/icons/Social/PinterestBrand2";

import YoutubeBrand1 from "../assets/icons/Social/YoutubeBrand1";
import YoutubeBrand2 from "../assets/icons/Social/YoutubeBrand2";

import WebBrand1 from "../assets/icons/Social/WebBrand1";

import Mail from "../assets/icons/Social/Mail";

import NoIcon from "assets/icons/Social/NoIcon";

export const SocialLinks = {
  web: "Web",
  instagram: "Instagram",
  facebook: "Facebook",
  linkedin: "LinkedIn",
  tiktok: "TikTok",
  linktree: "Linktree",
  spotify: "Spotify",
  pinterest: "Pinterest",
  youtube: "YouTube",
  twitter: "X",
  website: "Website",
  mail: "Mail",
};

export const SocialLinksArray = [
  { label: SocialLinks.facebook, value: SocialLinks.facebook },
  { label: SocialLinks.linkedin, value: SocialLinks.linkedin },
  { label: SocialLinks.tiktok, value: SocialLinks.tiktok },
  { label: SocialLinks.linktree, value: SocialLinks.linktree },
  { label: SocialLinks.instagram, value: SocialLinks.instagram },
  { label: SocialLinks.spotify, value: SocialLinks.spotify },
  { label: SocialLinks.pinterest, value: SocialLinks.pinterest },
  { label: SocialLinks.youtube, value: SocialLinks.youtube },
  { label: SocialLinks.twitter, value: SocialLinks.twitter },
  { label: SocialLinks.web, value: SocialLinks.web },
];

export const IconsArray = [
  { id: 1, icon: InstaBrand1 },
  { id: 2, icon: InstaBrand2 },

  { id: 3, icon: FacebookBrand1 },
  { id: 4, icon: FacebookBrand2 },

  { id: 5, icon: LinkedinBrand1 },
  { id: 6, icon: LinkedinBrand2 },

  { id: 7, icon: TikTokBrand1 },
  { id: 8, icon: TikTokBrand2 },

  { id: 9, icon: LinktreeBrand1 },
  { id: 10, icon: LinktreeBrand2 },

  { id: 11, icon: SpotifyBrand1 },
  { id: 12, icon: SpotifyBrand2 },

  { id: 13, icon: PinterestBrand1 },
  { id: 14, icon: PinterestBrand2 },

  { id: 15, icon: YoutubeBrand1 },
  { id: 16, icon: YoutubeBrand2 },

  { id: 17, icon: TwitterBrand1 },
  { id: 18, icon: TwitterBrand2 },

  { id: 19, icon: WebBrand1 },
  { id: 20, icon: NoIcon },
];

export const SocialIconsArray = {
  [SocialLinks.instagram]: [2, 1],
  [SocialLinks.facebook]: [3, 4],
  [SocialLinks.linkedin]: [6, 5],
  [SocialLinks.tiktok]: [7, 8],
  [SocialLinks.linktree]: [9, 10],
  [SocialLinks.spotify]: [11, 12],
  [SocialLinks.pinterest]: [13, 14],
  [SocialLinks.youtube]: [16, 15],
  [SocialLinks.twitter]: [17, 18],
  [SocialLinks.web]: [19],
  [SocialLinks.website]: [19],
};

export const platformPatterns = {
  Instagram: /^(https?:\/\/)?(www\.)?instagram\.com\/[A-Za-z0-9_.]+(\/.*)?$/i,

  Facebook:
    /^(https?:\/\/)?(www\.)?facebook\.com\/(profile\.php\?id=\d+|groups\/[A-Za-z0-9_.-]+|pages\/[A-Za-z0-9_.-]+\/\d+|events\/\d+|[A-Za-z0-9_.-]+)(\/.*)?$/i,

  LinkedIn:
    /^(https?:\/\/)?(www\.)?linkedin\.com\/(in|company|school|groups)\/[A-Za-z0-9_-]+(\/[\w-]*)?\/?$/i,

  TikTok:
    /^(https?:\/\/)?(www\.)?tiktok\.com\/(@[A-Za-z0-9_.]+|video\/\d+|t\/[A-Za-z0-9]+)(\/.*)?$/i,

  Linktree: /^(https?:\/\/)?(www\.)?linktr\.ee\/[A-Za-z0-9_.]+(\/.*)?$/i,

  Spotify:
    /^(https?:\/\/)?(open\.)?spotify\.com\/(user|artist|album|track|playlist)\/[A-Za-z0-9]+(\/.*)?$/i,

  Pinterest: /^(https?:\/\/)?(www\.)?pinterest\.com\/[A-Za-z0-9_\/-]+(\/.*)?$/i,

  YouTube:
    /^(https?:\/\/)?(www\.)?(youtube\.com\/(c|channel|user|watch\?v=|playlist\?list=)|youtu\.be\/)[A-Za-z0-9_-]+(\/.*)?$/i,

  X: /^(https?:\/\/)?(www\.)?(twitter\.com|x\.com)\/[A-Za-z0-9_]+(\/status\/\d+)?(\/.*)?$/i,

  Website:
    /^(https?:\/\/)?(www\.)?([A-Za-z0-9-]+\.)+[A-Za-z]{2,6}(\/[A-Za-z0-9._~:/?#[\]@!$&'()*+,;=]*)?$/i,

  Web: /^(https?:\/\/)?(www\.)?([A-Za-z0-9-]+\.)+[A-Za-z]{2,6}(\/[A-Za-z0-9._~:/?#[\]@!$&'()*+,;=]*)?$/i,
};

export const isSocialLinkValid = (url, platform) => {
  if (!platformPatterns[platform]) {
    throw new Error(`Unsupported platform: ${platform}`);
  }
  return platformPatterns[platform].test(url);
};

export const SocialIcons = {
  [SocialLinks.instagram]: InstaBrand2,
  [SocialLinks.facebook]: FacebookBrand1,
  [SocialLinks.linkedin]: LinkedinBrand2,
  [SocialLinks.tiktok]: TikTokBrand1,
  [SocialLinks.linktree]: LinktreeBrand1,
  [SocialLinks.spotify]: SpotifyBrand1,
  [SocialLinks.pinterest]: PinterestBrand1,
  [SocialLinks.youtube]: YoutubeBrand2,
  [SocialLinks.twitter]: TwitterBrand1,
  [SocialLinks.web]: WebBrand1,
  [SocialLinks.website]: WebBrand1,
  [SocialLinks.mail]: Mail,
};
